module.exports = __webpack_public_path__ + "14781d37a70f7bd4d1a92bac9300f575.png";